export enum DocumentSelectionType {
    Print = 'Print',
    Email = 'Email'
}